import axios from 'axios';
    import { logger } from '../utils/logging';

    const API_BASE_URL = 'https://openapi.nocodebackend.com';
    const INSTANCE_ID = import.meta.env.VITE_NOCODE_INSTANCE_ID || '54230_bpa_5e7gf';
    const API_KEY = import.meta.env.VITE_NOCODE_API_KEY || null;

    // Warn the developer in the console if the API key is missing during development.
    if (import.meta.env.DEV && !API_KEY) {
      console.warn(
        '%c[BPA Success Center] Configuration Warning:',
        'color: orange;font-weight: bold;',
        'The VITE_NOCODE_API_KEY environment variable is not set. API calls will fail. Please create a .env.local file or configure it in your deployment environment.'
      );
    }

    const ncbRequest = async (method, path, data = null, queryParams = {}) => {
      // Fail-fast check to prevent API calls without a key.
      if (!API_KEY) {
        const errorMessage = "Configuration Error: NoCodeBackend API Key is missing. Please set the VITE_NOCODE_API_KEY environment variable.";
        logger.error('API', 'Configuration Error', { message: errorMessage });
        throw new Error(errorMessage);
      }
      const url = `${API_BASE_URL}${path}`;
      const params = {
        ...queryParams,
        Instance: INSTANCE_ID,
      };
      const config = {
        method,
        url,
        params,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'apiKey': API_KEY,
        },
      };

      if (data) {
        config.data = data;
      }

      try {
        const response = await axios(config);
        logger.success('API', `${method.toUpperCase()} ${path}`, { status: response.status });
        if (response.status === 200 && !response.data) {
          return { success: true };
        }
        if (response.data.status === 'success' || response.status < 300) {
          return response.data;
        }
        throw new Error(response.data.message || `Request failed with status ${response.status}`);
      } catch (error) {
        const errorDetails = {
          message: error.message,
          status: error.response?.status,
          responseData: error.response?.data,
        };
        logger.error('API', `${method.toUpperCase()} ${path}`, errorDetails);
        console.error(`NoCodeBackend API Error: ${method} ${path}`, error.response?.data || error.message);
        throw error.response?.data || new Error('An unknown network error occurred');
      }
    };

    const nocodeClient = {
      read: (table, filters = {}) => ncbRequest('GET', `/read/${table}`, null, filters),
      create: (table, data) => ncbRequest('POST', `/create/${table}`, data),
      update: (table, id, data) => ncbRequest('PUT', `/update/${table}/${id}`, data),
      delete: (table, id) => ncbRequest('DELETE', `/delete/${table}/${id}`),
      search: (table, query) => ncbRequest('POST', `/search/${table}`, query),
    };

    export default nocodeClient;